import React, { memo } from 'react'
import cn from 'classnames'
import { useNavigate } from 'react-router-dom'
import { Button } from 'primereact/button'

import { WidgetLayout } from '../../../lib/widget-layout'
import { Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableBodyCell } from '../../../lib/table'
import Text from '../../../ui/Text'
import { Pool } from '../../../common/redux/api/web-api'
import useText from '../../../common/hooks/useText'

export type AdminUserAccessToPoolsWidgetProps = {
    pools: Pool[]
    isAdmin: boolean
    dataloadingPools: boolean
    style?: React.CSSProperties
    disableEdit: boolean
    userId: string
}

export const AdminUserAccessToPoolsWidget = memo(function AdminUserAccessToPoolsWidget({
    pools,
    style,
    isAdmin,
    dataloadingPools,
    disableEdit,
    userId,
}: AdminUserAccessToPoolsWidgetProps): React.ReactElement {
    const navigate = useNavigate()
    const text = useText()
    return (
        <div style={style}>
            <WidgetLayout
                title={<Text code="lblRFIDAccessToPools"></Text>}
                className={cn({ widgetprocessing: dataloadingPools })}
                headerButtons={
                    isAdmin ? (
                        <Button
                            type="button"
                            disabled={disableEdit}
                            label={text('btnEdit')}
                            icon="pi pi-pencil"
                            onClick={() => navigate(`/user/${userId}/userPools`)}
                            data-testid="btn-edit"
                        ></Button>
                    ) : (
                        <></>
                    )
                }
                data-testid="access-pools"
            >
                <Table data-testid="access-pools-table">
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell data-testid="lbl-name">
                                <Text code="lblName"></Text>
                            </TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {pools?.map((pool) => (
                            <TableRow key={pool.id} data-testid="name">
                                <TableBodyCell>{pool.name}</TableBodyCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </WidgetLayout>
        </div>
    )
})
